import { render, staticRenderFns } from "./card-title.component.vue?vue&type=template&id=af6db2ec&scoped=true&"
import script from "./card-title.component.vue?vue&type=script&lang=ts&"
export * from "./card-title.component.vue?vue&type=script&lang=ts&"
import style0 from "./card-title.component.vue?vue&type=style&index=0&id=af6db2ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6db2ec",
  null
  
)

export default component.exports